import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "order-item" };
const _hoisted_2 = { class: "order-item__description" };
const _hoisted_3 = { class: "order-item__tax-rate" };
const _hoisted_4 = {
    value: undefined,
    disabled: ""
};
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "order-item__price" };
const _hoisted_7 = { class: "order-item__quantity" };
const _hoisted_8 = { class: "order-item__quantity-input" };
const _hoisted_9 = ["disabled"];
import { computed, ref } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import NumberInput from "@astina/paloma-common-ui/src/components/NumberInput.vue";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import { formatCHF } from "@/utils/currency";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoNoticeItemDraft',
    props: {
        currency: {},
        taxRates: {}
    },
    emits: ['save'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const draft = ref({});
        const valid = computed(validateDraft);
        function taxRateLabel(taxRate) {
            const category = taxRate.categoryCode === 'reduced'
                ? trans('venso_tax_rate.reduced')
                : trans('venso_tax_rate.default');
            return `${category} ${formatCHF(Number(taxRate.rate) * 100)}%`;
        }
        function save() {
            if (!valid.value) {
                return;
            }
            emit('save', draft.value);
        }
        function onUnitPriceUpdate(price) {
            draft.value.unitPrice = price;
        }
        function onQuantityUpdate(qty) {
            draft.value.quantity = qty;
        }
        function validateDraft() {
            return !!(draft.value.description
                && draft.value.taxRate !== undefined
                && draft.value.unitPrice !== undefined
                && draft.value.quantity != undefined);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                _createElementVNode("td", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((draft.value.description) = $event)),
                        name: "description"
                    }, null, 512), [
                        [_vModelText, draft.value.description]
                    ])
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("td", _hoisted_3, [
                    _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((draft.value.taxRate) = $event)),
                        name: "taxRate"
                    }, [
                        _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t('venso_order_item.tax')), 1),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.taxRates, (taxRate) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: taxRate.categoryCode,
                                value: Number(taxRate.rate)
                            }, _toDisplayString(taxRateLabel(taxRate)), 9, _hoisted_5));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, draft.value.taxRate]
                    ])
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1)),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(__props.currency) + " ", 1),
                        _createVNode(NumberInput, {
                            value: draft.value.unitPrice,
                            onChange: onUnitPriceUpdate,
                            min: 0,
                            decimals: 2
                        }, null, 8, ["value"])
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _cache[9] || (_cache[9] = _createElementVNode("td", { colspan: "2" }, null, -1)),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(NumberInput, {
                                value: draft.value.quantity,
                                onChange: onQuantityUpdate,
                                min: 0
                            }, null, 8, ["value"])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("button", {
                            onClick: _withModifiers(save, ["prevent"]),
                            disabled: !valid.value,
                            class: "button button--outline button--icon button--small"
                        }, [
                            _createVNode(Icon, { name: "save" })
                        ], 8, _hoisted_9)
                    ])
                ])
            ]));
        };
    }
});
